function PrivacyPolicyPage({ onBack }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary to-purple-600 px-4 py-12">
      <div className="w-full max-w-2xl">
        {/* 헤더 */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center size-16 rounded-full bg-white shadow-lg mb-4">
            <span className="material-symbols-outlined text-primary text-4xl">auto_awesome</span>
          </div>
          <h1 className="text-4xl font-black text-white mb-2">InstaAuto</h1>
        </div>

        {/* 개인정보 처리방침 카드 */}
        <div className="bg-white dark:bg-[#111118] rounded-2xl shadow-2xl p-8 border border-slate-200 dark:border-[#282839]">
          {/* 상단 네비게이션 */}
          <div className="flex items-center justify-between mb-6">
            <button
              onClick={onBack}
              className="flex items-center gap-1 text-sm text-primary hover:underline font-medium"
            >
              <span className="material-symbols-outlined text-base">arrow_back</span>
              뒤로가기
            </button>
            <span className="text-xs text-slate-400">시행일: 2026.03.11</span>
          </div>

          <h2 className="text-2xl font-bold text-center mb-4 text-slate-900 dark:text-white">
            개인정보 처리방침
          </h2>

          <p className="text-sm text-slate-600 dark:text-slate-400 mb-8 text-center leading-relaxed">
            InstaAuto(이하 "회사")는 개인정보보호법 제30조에 따라 정보주체의 개인정보를 보호하고
            이와 관련한 고충을 신속하고 원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
          </p>

          {/* 본문 */}
          <div className="space-y-6 text-sm leading-relaxed text-slate-700 dark:text-slate-300">
            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제1조 (수집하는 개인정보 항목)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>필수 항목: 아이디, 비밀번호, 이름</li>
                <li>선택 항목: 이메일, 전화번호</li>
                <li>서비스 이용 과정에서 자동 수집: 접속 로그, IP 주소, 쿠키, 서비스 이용 기록</li>
                <li>인스타그램 연동 시: 인스타그램 사용자명, 프로필 정보, 비즈니스 계정 ID</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제2조 (개인정보의 수집 및 이용 목적)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>회원 관리: 회원제 서비스 이용, 본인 확인, 불량회원 부정이용 방지</li>
                <li>서비스 제공: 콘텐츠 자동화, 이미지 생성, DM 자동응답, 게시물 예약</li>
                <li>고객 상담: 불만 처리, 공지사항 전달</li>
                <li>서비스 개선: 통계 분석, 서비스 품질 향상</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제3조 (개인정보의 보유 및 이용 기간)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>회원 탈퇴 시까지 보유하며, 탈퇴 즉시 파기합니다.</li>
                <li>관계 법령에 따라 보존이 필요한 경우:</li>
              </ol>
              <ul className="list-disc list-inside space-y-1 ml-6 mt-1">
                <li>계약 또는 청약철회에 관한 기록: 5년 (전자상거래법)</li>
                <li>소비자 불만 또는 분쟁 처리에 관한 기록: 3년 (전자상거래법)</li>
                <li>접속 로그: 3개월 (통신비밀보호법)</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제4조 (개인정보의 제3자 제공)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>회사는 원칙적으로 정보주체의 개인정보를 제3자에게 제공하지 않습니다.</li>
                <li>다만, 다음의 경우에는 예외로 합니다:</li>
              </ol>
              <ul className="list-disc list-inside space-y-1 ml-6 mt-1">
                <li>정보주체가 사전에 동의한 경우</li>
                <li>법률에 특별한 규정이 있는 경우</li>
                <li>수사 목적으로 법령에 정해진 절차에 따라 요청이 있는 경우</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제5조 (개인정보 처리 위탁)</h3>
              <p className="mb-2">회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보를 위탁합니다:</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Meta Platforms (인스타그램 API 연동)</li>
                <li>Google Cloud (AI 이미지 생성 - Gemini API)</li>
              </ul>
              <p className="mt-2">위탁 업무 내용 및 수탁자가 변경될 경우 공지합니다.</p>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제6조 (개인정보의 파기)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>보유 기간 경과, 처리 목적 달성 시 지체 없이 파기합니다.</li>
                <li>전자 파일: 복구할 수 없는 방법으로 영구 삭제</li>
                <li>종이 문서: 분쇄기로 분쇄 또는 소각</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제7조 (정보주체의 권리·의무 및 행사 방법)</h3>
              <p className="mb-2">정보주체는 언제든지 다음의 권리를 행사할 수 있습니다:</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>개인정보 열람 요구</li>
                <li>오류 등이 있을 경우 정정 요구</li>
                <li>삭제 요구</li>
                <li>처리 정지 요구</li>
              </ul>
              <p className="mt-2">권리 행사는 서비스 내 설정 또는 이메일을 통해 가능합니다.</p>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제8조 (개인정보 보호책임자)</h3>
              <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고 처리와 관련한 불만 처리 및 피해 구제를 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
              <ul className="list-disc list-inside space-y-1 ml-2 mt-2">
                <li>담당부서: 서비스 운영팀</li>
                <li>연락처: 서비스 내 문의</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제9조 (개인정보 자동 수집 장치)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 쿠키를 사용합니다.</li>
                <li>쿠키는 웹사이트 서버가 이용자의 브라우저에 보내는 소량의 정보입니다.</li>
                <li>이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제10조 (처리방침 변경)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>본 개인정보 처리방침은 법령·정책·보안기술의 변경에 따라 변경될 수 있습니다.</li>
                <li>변경 시 시행일 7일 전부터 서비스 내 공지합니다.</li>
              </ol>
            </section>

            <section className="pt-4 border-t border-slate-200 dark:border-[#282839]">
              <p className="font-semibold text-slate-900 dark:text-white">부칙</p>
              <p>본 처리방침은 2026년 3월 11일부터 시행합니다.</p>
            </section>
          </div>
        </div>

        {/* 저작권 */}
        <div className="text-center mt-6">
          <p className="text-white/60 text-sm">&copy; 2024 InstaAuto. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
